import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  FormGroup,
  CardBody,
  Label,
  Alert,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import FootprintDatePicker from "../../../../Components/utils/FootprintDatePicker";
import FootprintInputText from "../../../../Components/utils/FootprintInputText";
import FootprintInputButton from "../../../../Components/utils/FootprintInputButton";
import moment from "moment";
import { DEFAULT_FORMAT } from "../../../../Components/utils/FootprintDatePicker";
import { useRequestProcessor } from "../../../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail, mobileAtom } from "../../../../AtomStore/store";

import { handleNonSatisfactory } from "../../../../QueryFunctions/queryfunction";
import SpinnerLoading from "../../../../Components/utils/SpinnerLoading";
import { useNavigate } from "react-router-dom";
import { StyledCardHeader } from "../styles";

const NonSatisfaction = () => {
  const { useMutationWrapper } = useRequestProcessor();

  const navigate = useNavigate();

  const [activeChild] = useAtom(activeChildDetail);
  const [state, setState] = useState({
    showMsg: "false",
    successMsg: "",
    errorMsg: "",
    fromDate: "",
    comment: "",
    amount: "",
    selectedDate: "",
    //moment().format(DEFAULT_FORMAT)
  });
  useEffect(() => {
    console.log(
      "[Non Satisfaction Refund] Initializing non-satisfaction refund form  for child:",
      activeChild?.id
    );
  }, [activeChild]);
  const nonSatisfactory = useMutationWrapper(
    "nonSatisfactory",
    () => {
      console.log(
        "[Non Satisfaction Refund] Calling API:/financials/saveNonSatisfactionRefund",
        state
      );
      return handleNonSatisfactory(state, navigate);
    },
    {
      onSuccess: (data) => {
        console.log(
          "[Non Satisfaction Refund] Non Satisfaction Refund response:",
          data
        );
      },
    }
  );

  const validate = () => {
    if (state.holidaySelected === true) {
      setState({ ...state, error: "The Selected Date Cannot Be a Holiday" });
      return false;
    } else if (state.selectedDate === "") {
      setState({ ...state, error: "Please Select Date" });
      return false;
    } else if (state.comment === "") {
      setState({ ...state, error: "Please Enter Comment" });
      return false;
    } else {
      return true;
    }
  };

  const submit = () => {
    if (validate()) {
      nonSatisfactory.mutate();
    } else {
    }
  };
  return (
    <div className="m-[10px] mt-[20px]">
      {nonSatisfactory.isLoading && <SpinnerLoading />}

      <div className="bg-white rounded shadow p-2 pb-4 card-timeline">
        <div className="pt-4 md:p-2">
          <form className="space-y-4">
            {/* Alert messages */}
            {(state.successMsg !== "" || state.errorMsg !== "") && (
              <div>
                {state.successMsg && (
                  <div className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded mb-3 font-medium">
                    {state.successMsg}
                  </div>
                )}
                {state.errorMsg && (
                  <div className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded font-medium">
                    {state.errorMsg}
                  </div>
                )}
              </div>
            )}

            {state.errorMsg === "" && (
              <div className="grid grid-cols-1  gap-2">
                {/* Date Picker */}
                <div className="md:w-90">
                  <label
                    htmlFor="startDate"
                    className="block text-sm font-medium text-black mb-1"
                  >
                    Date
                  </label>
                  <div className="flex items-center ">
                    <FootprintDatePicker
                      holidaySelected={(selected) =>
                        setState({
                          ...state,
                          error: "The selected Date Cannot Be a Holiday",
                          holidaySelected: selected,
                        })
                      }
                      maximumDate={moment()}
                      minimumDate={moment().subtract(2, "days")}
                      defaultDate={state.selectedDate}
                      onChange={(date) =>
                        setState({
                          ...state,
                          holidaySelected: false,
                          selectedDate: moment(date).format(DEFAULT_FORMAT),
                          error: "",
                        })
                      }
                      inputProps={{
                        placeholder: "Select Date",
                      }}
                    />
                    <i className="icon-calender text-2xl text-black mr-2" />
                  </div>
                </div>
                <hr className=" mx-2 bg-black md:hidden" />

                {/* Reason Input */}
                <div className="mb-4">
                  <label
                    htmlFor="reason"
                    className="block text-sm font-medium text-black mb-1"
                  >
                    Reason
                  </label>
                  <FootprintInputText
                    type="text"
                    placeholder="Reason"
                    onChange={(value) =>
                      setState({ ...state, comment: value, error: "" })
                    }
                    name="text"
                  />
                </div>

                {/* Error message */}
                {state.error && (
                  <p className="text-red-600 text-sm col-span-full">
                    {state.error}
                  </p>
                )}

                {/* Submit Button */}
                <div className="col-span-full text-center">
                  <FootprintInputButton onClick={submit} />
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default NonSatisfaction;
